import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getAutocompleteModel from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import updateSearchFields from "@MasterBluePrint/Store/Pages/RfqMyQuotes/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@MasterBluePrint/Widgets/RfqMyQuotes/SearchTextField";
import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import React, { ChangeEvent, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export const quoteSearchFieldRequestedByStyles: SearchTextFieldStyles = {};
const styles = quoteSearchFieldRequestedByStyles;

const QuoteSearchFieldAmount: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            testSelector="quote_filterRequestedBy"
            styles={styles}
            parameterField="requestedBy"
            label="Requested by"
            inputType="text"
            placeholder="Enter Requested By"
        />
    );
};

const widgetModule: WidgetModule = {
    component: QuoteSearchFieldAmount,
    definition: {
        group: "RFQ My Quotes",
        displayName: "Requested By",
    },
};

export default widgetModule;